import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'SunLowIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-sun-low",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 12m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M4 12h.01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 4v.01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M20 12h.01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M12 20v.01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M6.31 6.31l-.01 -.01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M17.71 6.31l-.01 -.01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M17.7 17.7l.01 .01"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M6.3 17.7l.01 .01"
    }, null), _createTextVNode(" ")]);
  }
};